import type { CommentPerson } from "@/domain/comment";

export function commentMentionText(body: string, mentions: CommentPerson[]): string {
  const names = new Map(mentions.map((person) => [person.uuid, person.name]));
  return body.replace(/@\[([0-9a-f-]+)\]/gi, (token, uuid: string) => {
    const name = names.get(uuid);
    return name ? `@${name}` : token;
  });
}
export function commentMentionBody(text: string, people: CommentPerson[]): string {
  let body = text;
  for (const person of [...people].sort((a, b) => b.name.length - a.name.length)) {
    const literal = person.name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    body = body.replace(new RegExp(`@${literal}(?=$|[\\s.,!?;:])`, "g"), `@[${person.uuid}]`);
  }
  return body;
}
